'use strict';

angular.module('shiftTraderApp')
    .directive('saProfilePicture', ['$compile', function ($compile) {
      var linkTemplate = '<a class="sa_profile_picture" ui-sref="profile.main(::{userId: user.id})" target="_blank">' +
        '<div class="{{ ::outerProfilePictureClass }}">' +
        '<div class="{{ ::theRightNoImgClass }}" data-ng-if="::user.avatar_urls.profile.slice(-11) === \'missing.jpg\'">' +
        '<div style="width:100%;text-align:center;">{{::userInitials}}</div>' +
        '</div>' +
        '<img class="{{ ::theRightImgClass }}" data-ng-src="{{::imgUrl}}" alt="{{::user.name}}">' +
        '</div>' +
        '</a>';

    var noLinkTemplate = '<div class="{{ ::outerProfilePictureClass }}">' +
      '<div class="{{ ::theRightNoImgClass }}" data-ng-if="::user.avatar_urls.profile.slice(-11) === \'missing.jpg\'">' +
      '<div style="width:100%;text-align:center;">{{::userInitials}}</div>' +
      '</div>' +
      '<img class="{{ ::theRightImgClass }}" data-ng-src="{{::imgUrl}}" alt="{{::user.name}}">' +
      '</div>';


      return {
        restrict: 'A',
        scope: {
          user: '=saProfilePicture',
          size: '@',
          watchUser: '@',
          link: '@'
        },
        replace:true,
        link: function(scope, elem) {
          var initialize = function() {
            scope.userInitials = scope.user.first_name[0] + scope.user.last_name[0];
            if (scope.size === 'profile') {
              scope.theRightImgClass = 'user_profile_img';
              scope.theRightNoImgClass = 'place_initials_64x';
              scope.imgUrl = scope.user.avatar_urls.profile;
              scope.outerProfilePictureClass = 'profile_picture_64x';
            } else if (scope.size === 'thumb') {
              scope.theRightImgClass = 'user_thumb_img';
              scope.theRightNoImgClass = 'place_initials_64x';
              scope.imgUrl = scope.user.avatar_urls.thumb;
              scope.outerProfilePictureClass = 'profile_picture_64x';
            } else if (scope.size === 'tiny') {
              scope.theRightImgClass = 'user_tiny_img';
              scope.theRightNoImgClass = 'place_initials_32x';
              scope.imgUrl = scope.user.avatar_urls.tiny;
              scope.outerProfilePictureClass = 'profile_picture_32x';
            } else if (scope.size === 'super_tiny') {
              scope.theRightImgClass = 'user_super_tiny_img';
              scope.theRightNoImgClass = 'place_initials_24x';
              scope.imgUrl = scope.user.avatar_urls.tiny;
              scope.outerProfilePictureClass = 'profile_picture_24x';
            } else if (scope.size === 'medium') {
              scope.theRightImgClass = 'user_medium_img';
              scope.theRightNoImgClass = 'place_initials_300x';
              scope.imgUrl = scope.user.avatar_urls.medium;
              scope.outerProfilePictureClass = 'profile_picture_300x';
            } else {
              console.error('NOT A VALID PROFILE PICTURE SIZE!!!');
            }

            if (scope.link !== 'false') {
              elem.html($compile(linkTemplate)(scope));
            } else {
              elem.html($compile(noLinkTemplate)(scope));
            }

            if (scope.watchUser !== 'true' && userAvatarWatchDereg) {
              userAvatarWatchDereg();
            }
          };

          if (!_.isUndefined(scope.user) && !_.isNull(scope.user)) {
            initialize();
          }

          if (scope.watchUser === 'true') {
            scope.$watch('user.id', function () {
              if (!_.isUndefined(scope.user) && !_.isNull(scope.user)) {
                initialize();
              } else {
                elem.empty();
              }
            });
          }

          var userAvatarWatchDereg = scope.$watch('user.avatar_urls.tiny', function(newVal) {
            if (!_.isUndefined(scope.user) && !_.isNull(scope.user) && newVal) {
              initialize();
            }
          });


        }
      };
    }]);
